import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_openBlock(), _createBlock(_component_ComboBox, {
    key: _ctx.componentKey,
    style: _normalizeStyle({ width: _ctx.comboBoxWidth }),
    "data-items": _ctx.dataItems,
    "text-field": 'value',
    "data-item-key": 'key',
    "allow-custom": true,
    filterable: true,
    "value-field": 'key',
    "value-primitive": true,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    label: _ctx.label,
    tabIndex: _ctx.tabIndex,
    size: "small",
    "floating-label": _ctx.noLabel,
    onChange: _ctx.selectionChanged,
    onFilterchange: _ctx.filterChanged
  }, null, 8, ["style", "data-items", "modelValue", "label", "tabIndex", "floating-label", "onChange", "onFilterchange"]))
}